import React, { useState } from "react";
// import axios from "axios";
import API from "../api/api";
import { nanoid } from "nanoid";
import { toast } from "react-toastify";
const AdminDashboard = () => {
  const [product, setProduct] = useState({
    id: nanoid(),
    name: "",
    description: "",
    price: 0,
    category_id: "",
    supplier_id: "",
    stock_quantity: 0,
    unit: "",
    image: "",
  });

  const [fields] = useState([
    { label: "Title", name: "name", type: "text" },
    { label: "Description", name: "description", type: "text" },
    { label: "Prix", name: "price", type: "number" },
    { label: "Quantity", name: "stock_quantity", type: "number" },
    { label: "Image URL", name: "image", type: "text" },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduct({
      ...product,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    API.post("products", product, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        toast.success("Votre Produit à bien été ajouté");
      })
      .catch((error) => {
       toast.error("Un problème est survenu veuiller contacter le service client");
      });
  };

  return (
    <div className="max-w-2xl mx-auto p-8 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-6">Admin Dashboard</h2>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
          {fields.map((input, index) => (
            <div className="mb-4" key={index}>
              <label className="block text-gray-700 font-bold mb-2">
                {input.label}:
              </label>
              {/* {input.name === "id" ? (
                <span className="text-sm">{product[input.name]}</span>
              ) : ( */}
              <input
                type={input.type}
                name={input.name}
                value={product[input.name]}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {/* )} */}
            </div>
          ))}
          <div className="mb-4">
            <label className="block text-gray-700 font-bold mb-2">
              In Stock:
            </label>
            <input
              type="checkbox"
              name="isInStock"
              checked={product.Status}
              onChange={() =>
                setProduct({ ...product, Status: !product.Status })
              }
              className="mr-2 leading-tight"
            />
          </div>
        </div>
        <button
          type="submit"
          className="w-full bg-blue-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          Add Product
        </button>
      </form>
    </div>
  );
};

export default AdminDashboard;
